// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { readOnlyBinaryProperty, readOnlyProperty, frozenClass, } from './immutable_class';
import { needs } from './needs';
export class EncryptedDataKey {
    constructor(edkInput) {
        const { providerInfo, providerId, encryptedDataKey, rawInfo } = edkInput;
        needs(typeof providerInfo === 'string' &&
            providerInfo &&
            typeof providerId === 'string' &&
            providerId &&
            encryptedDataKey instanceof Uint8Array &&
            encryptedDataKey.byteLength, 'Malformed encrypted data key');
        readOnlyProperty(this, 'providerInfo', providerInfo);
        readOnlyProperty(this, 'providerId', providerId);
        readOnlyBinaryProperty(this, 'encryptedDataKey', encryptedDataKey);
        if (rawInfo instanceof Uint8Array) {
            readOnlyBinaryProperty(this, 'rawInfo', rawInfo);
        }
        else {
            readOnlyProperty(this, 'rawInfo', undefined);
        }
        Object.setPrototypeOf(this, EncryptedDataKey.prototype);
        Object.freeze(this);
    }
}
frozenClass(EncryptedDataKey);
